const PRESETS = [
  { label: "Glow", x: 0, y: 0, blur: 18, color: "rgba(130,100,255,0.95)" },
  { label: "Hard", x: 4, y: 4, blur: 0, color: "rgba(0,0,0,0.9)" },
  { label: "Neon", x: 0, y: 0, blur: 12, color: "rgba(0,255,180,0.95)" },
  { label: "Lift", x: 2, y: 6, blur: 10, color: "rgba(0,0,0,0.5)" },
  { label: "Fire", x: 0, y: 4, blur: 14, color: "rgba(255,100,20,0.9)" },
];
export default PRESETS;
